module.exports = __webpack_public_path__ + "img/successImage.f82a4c68.png";